import { useEffect, useState } from 'react'
import { Wand2, ChevronDown, ClipboardCopy } from 'lucide-react'
import toast from 'react-hot-toast'

// Clever Humanizer widget (client-side only: no API, so it cannot run from the backend).
// ponytail: the widget has its own input box, so we copy the chapter text and the user pastes the result back by hand.
const WIDGET_ID = '87bdb230f08b41b1ac1cb6ed9d7717b3'
const SCRIPT_SRC = 'https://widgets.cleverhumanizer.ai/widget.js'

export default function HumanizePanel({ getText }) {
  const [open, setOpen] = useState(false)

  // The widget scans the page when its script loads, so load it after the container exists and drop it on close.
  useEffect(() => {
    if (!open) return undefined
    const s = document.createElement('script')
    s.src = SCRIPT_SRC
    s.async = true
    document.body.appendChild(s)
    return () => { s.remove() }
  }, [open])

  const copy = async () => {
    const text = (getText?.() || '').trim()
    if (!text) return toast.error('Chapter is empty')
    try {
      await navigator.clipboard.writeText(text)
      toast.success('Chapter text copied. Paste it into the box below.')
    } catch {
      toast.error('Could not copy. Select the text in the editor and copy it.')
    }
  }

  return (
    <div className="space-y-2">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center gap-3 px-3 py-2 rounded-lg font-sans text-sm text-acdyon-textMuted hover:text-acdyon-text transition-colors"
        style={{ border: '1px solid #DDE4EF' }}
        aria-expanded={open}
      >
        <Wand2 style={{ width: 14, height: 14 }} />
        Humanize
        <ChevronDown style={{ width: 12, height: 12, marginLeft: 'auto', transform: open ? 'rotate(180deg)' : 'none' }} />
      </button>
      {open && (
        <div className="space-y-2 p-2 rounded-lg" style={{ border: '1px solid #DDE4EF' }}>
          <button
            onClick={copy}
            className="w-full flex items-center gap-2 px-3 py-1.5 rounded-lg font-sans text-xs text-acdyon-textMuted hover:text-acdyon-text"
            style={{ border: '1px solid #DDE4EF' }}
          >
            <ClipboardCopy style={{ width: 12, height: 12 }} /> Copy chapter text
          </button>
          <div data-clever-widget={WIDGET_ID} data-theme="light" />
          <p className="font-sans text-xs text-acdyon-textFaint">
            Text you paste here is sent to Clever AI, a third party. Paste the result back into the editor yourself.
          </p>
        </div>
      )}
    </div>
  )
}
